import type { BetSlipState } from '../types';

const promotionRemoved = (state: BetSlipState): BetSlipState => ({
  ...state,
  selectedPromotion: undefined
});

export default promotionRemoved;
